// extracted by mini-css-extract-plugin
module.exports = {"container":"jhOjQrNV9bfO9jxSKbmNO","title":"_3TF5GUpNIYnGNDbkZhxML2 appSubtitle"};